import { Calendar, Users } from 'lucide-react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
interface SimplifiedSearchSummaryProps {
  checkIn?: Date;
  checkOut?: Date;
  guests: string;
  onClick: () => void;
}
const SimplifiedSearchSummary = ({
  checkIn,
  checkOut,
  guests,
  onClick
}: SimplifiedSearchSummaryProps) => {
  const formatDateRange = () => {
    if (!checkIn || !checkOut) return "Agregar fechas";
    const startDay = format(checkIn, "d", {
      locale: es
    });
    const endDay = format(checkOut, "d", {
      locale: es
    });
    const month = format(checkIn, "MMM", {
      locale: es
    });
    return `${startDay}-${endDay} de ${month}`;
  };
  const formatGuests = () => {
    const guestCount = parseInt(guests) || 1;
    return guestCount === 1 ? '1 huésped' : `${guestCount} huéspedes`;
  };
  return <div onClick={onClick} className="bg-white rounded-xl shadow-sm border border-gray-200 p-3 cursor-pointer hover:shadow-md transition-shadow mx-2">
      {/* Header */}
      <div className="mb-1">
        <h2 className="text-base font-semibold text-gray-900 text-center">Alojamientos en Manzanillo</h2>
      </div>
      
      {/* Search summary */}
      <div className="flex justify-center gap-4 text-sm text-gray-600">
        <div className="flex items-center gap-1">
          <Calendar className="h-4 w-4" />
          <span>{formatDateRange()}</span>
        </div>
        
        <div className="flex items-center gap-1">
          <Users className="h-4 w-4" />
          <span>{formatGuests()}</span>
        </div>
      </div>
    </div>;
};
export default SimplifiedSearchSummary;